<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title>
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <div v-if="hasWarning" class="text-error">
          {{ payload.warning }}
        </div>
        <v-alert variant="outlined" color="error" icon="mdi-alert" :value="true" v-if="showError">
          Une erreur est survenue, vérifier vos informations et réessayez.
        </v-alert>
        <v-form v-model="valid">
          <div class="d-flex my-2">
            <v-text-field
              ref="name"
              label="Nom"
              name="name"
              placeholder="Nom"
              :rules="[rules.required]"
              v-model="labor.name"
              :error="errors.name"
              :disabled="disabledName"
            ></v-text-field>
          </div>
          <div class="d-flex my-2">
            <v-text-field
              ref="residentialCost"
              label="Résidentiel"
              v-model="labor.userLaborCosts.residentialCost"
              name="residentialCost"
              placeholder="Coût"
              :rules="[rules.cost]"
              :error="errors.residentialCost"
              :error-messages="errMessResidential"
              type="number"
            ></v-text-field>
          </div>
          <div class="d-flex my-2">
            <v-text-field
              ref="commercialCost"
              label="Commercial"
              v-model="labor.userLaborCosts.commercialCost"
              name="commercialCost"
              placeholder="Coût"
              :rules="[rules.cost]"
              :error="errors.commercialCost"
              :error-messages="errMessCommercial"
              type="number"
            ></v-text-field>
          </div>
          <div class="d-flex my-2">
            <v-text-field
              ref="industrialCost"
              label="Industriel"
              v-model="labor.userLaborCosts.industrialCost"
              name="industrialCost"
              placeholder="Coût"
              :rules="[rules.cost]"
              :error="errors.industrialCost"
              :error-messages="errMessIndustrial"
              type="number"
            ></v-text-field>
          </div>
          <div class="d-flex my-2">
            <v-text-field
              ref="civilEngineeringCost"
              label="Génie civil/voirie"
              v-model="labor.userLaborCosts.civilEngineeringCost"
              name="civilEngineeringCost"
              placeholder="Coût"
              :rules="[rules.cost]"
              :error="errors.civilEngineeringCost"
              :error-messages="errMessCivil"
              type="number"
            ></v-text-field>
          </div>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="close"> Annuler </v-btn>
      <v-btn color="primary" variant="text" @click="submit" :disabled="!valid"> Confirmer </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { Get, Save } from '@/_services/labors';

export default {
  components: {},
  mixins: [DialogPropsMixin],
  data: () => ({
    valid: true,
    title: 'Modification du corps de métier',
    rules: {
      required: value => !!value || 'Champ requis.',
      cost: value => {
        const pattern = /^\d*(\.\d+)?$/;
        if (pattern.test(value) && Number.isFinite(Number.parseFloat(value))) {
          return true;
        } else if (value === null || value === '') {
          return true;
        }
        return 'Coût invalide.';
      },
    },
    sent: false,
    nameError: false,
    showError: false,
    errMessResidential: '',
    errMessCommercial: '',
    errMessIndustrial: '',
    errMessCivil: '',
    disabledName: false,
    resetData: {},
    labor: {
      id: 0,
      name: '',
      residentialCost: null,
      commercialCost: null,
      industrialCost: null,
      civilEngineeringCost: null,
      userLaborCosts: {
        residentialCost: null,
        commercialCost: null,
        industrialCost: null,
        civilEngineeringCost: null,
      },
    },
    errors: {
      name: false,
      residentialCost: false,
      commercialCost: false,
      industrialCost: false,
      civilEngineeringCost: false,
    },
  }),
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    hasWarning() {
      return !!this.payload.warning;
    },
  },
  methods: {
    getDataFromApi() {
      Get(this.payload.laborId).then(rep => {
        this.resetData = rep;
        this.resetData.id = this.payload.laborId;
        this.title = `Modification du corps de métier - ${rep.name}`;
        this.clear();
      });
    },
    submit() {
      this.formIsValid();

      if (this.valid) {
        this.sent = true;

        Save(this.labor)
          .then(() => {
            if (this.payload.emits) {
              this.$bus.emit(this.payload.emits);
            }
            this.close();
          })
          .catch(() => {
            this.showError = true;
            this.sent = false;
          });
      } else {
        this.showError = true;
      }
    },
    close() {
      this.clear();
      this.$emit('close');
    },
    clear() {
      this.labor = {
        id: this.resetData.id,
        name: this.resetData.name,
        residentialCost: this.resetData.residentialCost,
        commercialCost: this.resetData.commercialCost,
        industrialCost: this.resetData.industrialCost,
        civilEngineeringCost: this.resetData.civilEngineeringCost,
        userLaborCosts: null,
      };
      if (this.resetData.userLaborCosts) {
        this.labor.userLaborCosts = {
          residentialCost: this.resetData.userLaborCosts.residentialCost,
          commercialCost: this.resetData.userLaborCosts.commercialCost,
          industrialCost: this.resetData.userLaborCosts.industrialCost,
          civilEngineeringCost: this.resetData.userLaborCosts.civilEngineeringCost,
        };
      } else {
        this.labor.userLaborCosts = {
          residentialCost: this.resetData.residentialCost,
          commercialCost: this.resetData.commercialCost,
          industrialCost: this.resetData.industrialCost,
          civilEngineeringCost: this.resetData.civilEngineeringCost,
        };
      }
      this.resetErrors();
    },
    resetErrors() {
      this.errors = {
        name: false,
        residentialCost: false,
        commercialCost: false,
        industrialCost: false,
        civilEngineeringCost: false,
      };
      this.errMessResidential = '';
      this.errMessCommercial = '';
      this.errMessIndustrial = '';
      this.errMessCivil = '';
      this.showError = false;
    },
    formIsValid() {
      this.valid = true;
      this.resetErrors();

      if (!this.$refs['name'].valid) {
        this.valid = false;
        this.errors.name = true;
      }
      if (!this.costValid()) {
        this.valid = false;
      }
    },
    costValid() {
      let residential = this.$refs['residentialCost'].value;
      let civilEngineering = this.$refs['civilEngineeringCost'].value;
      let industrial = this.$refs['industrialCost'].value;
      let commercial = this.$refs['commercialCost'].value;
      let costValid = true;
      if (residential === '') {
        this.labor.userLaborCosts.residentialCost = null;
      }
      if (!this.$refs['residentialCost'].valid) {
        costValid = false;
      }
      if (civilEngineering === '') {
        this.labor.userLaborCosts.civilEngineeringCost = null;
      }
      if (!this.$refs['civilEngineeringCost'].valid) {
        costValid = false;
      }
      if (industrial === '') {
        this.labor.userLaborCosts.industrialCost = null;
      }
      if (!this.$refs['industrialCost'].valid) {
        costValid = false;
      }
      if (commercial === '') {
        this.labor.userLaborCosts.commercialCost = null;
      }
      if (!this.$refs['commercialCost'].valid) {
        costValid = false;
      }
      if (residential === null && civilEngineering === null && industrial === null && commercial === null) {
        costValid = false;
        this.errors.residentialCost = true;
        this.errors.civilEngineeringCost = true;
        this.errors.industrialCost = true;
        this.errors.commercialCost = true;
        this.errMessResidential = 'Coût invalide';
        this.errMessCommercial = 'Coût invalide';
        this.errMessIndustrial = 'Coût invalide';
        this.errMessCivil = 'Coût invalide';
      }
      return costValid;
    },
  },
};
</script>

<style lang="css" scoped>
.form-btn {
  margin-top: 20px;
}

.hide {
  display: none;
}
</style>
